import React from "react";
import { Actif } from "../../interfaces";
import CustomDialog from "../CustomDialog";

interface ModalDeleteActifProps {
  closeModalDelete: () => void;
  modalIsOpenDelete: boolean;
  deleteActif: (id: number) => void;
  selectedActif: Actif;
}

const ModalDeleteActif = ({
  closeModalDelete,
  modalIsOpenDelete,
  deleteActif,
  selectedActif,
}: ModalDeleteActifProps) => {
  return (
    <>
      <CustomDialog
        visible={modalIsOpenDelete}
        closeModalDialog={() => {
          closeModalDelete();
        }}
      >
        <div className="relative w-full h-full ">
          <div className="p-6 text-center">
            <svg
              aria-hidden="true"
              className="mx-auto mb-4 text-gray-400 w-14 h-14 dark:text-gray-200"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Êtes-vous sûr de supprimer{" "}
              <strong>{selectedActif?.nom_actif} </strong> ?
            </h3>
            {/* <div
              className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-5"
              role="alert"
            >
              <p className="font-bold">Attention !!</p>
              <p>
                Lors de la suppression d'un actif,{" "}
                <strong>
                  tous les entités géospatiales attachés vont être supprimer
                  définitivement{" "}
                </strong>
                ,
                <strong className="flex justify-center">
                  les unités d'organisations{" "}
                  <img className="ml-2" src="/images/unite.png" />{" "}
                </strong>
                ainsi que <strong> les livrables en correspondances.</strong>
              </p>
            </div> */}

            <button
              data-modal-hide="popup-delete"
              type="button"
              onClick={() => {
                deleteActif(selectedActif.id);
                closeModalDelete();
              }}
              className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
            >
              Oui, je suis sûr
            </button>
            <button
              onClick={closeModalDelete}
              type="button"
              className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
            >
              Non, annuler
            </button>
          </div>
        </div>
      </CustomDialog>
    </>
  );
};

export default ModalDeleteActif;
